export default '/build/53f6ec69.svg'